import { AuthModel } from '@gtpl/shared-models/common-models';
import { stockDropdownData, } from '@gtpl/shared-models/common-models';
import { BrandReqForLocation, CommonResponse, ItemCategoriesDropDownResponseModel, ItemRequest, ItemsDropDownResponseModel, ItemSubCategoriesDropDownResponse, SizesDropDownResponseModel } from '@gtpl/shared-models/masters';
import { AllStockResponseModel, AvailableStockQtyResponseModel, GetAvailableStockResponse, StockQtyResponseModel, StockDto, ProductConversionModel, PlantItemSubCategoryIdReq, CycleCheckerDto, ItemIdReq, LocationUpdateRequest, ReClassificationReq, InventoryLogsDto } from '@gtpl/shared-models/procurement-management';
import { ItemsDetailsResponseModel, SaleOrderDropDownResponseModel, SaleOrderIdsRequest } from '@gtpl/shared-models/sale-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { CategorySubCategoryReq } from './dto/category- sub-category-id.reqest';
import { CycleCheckerDTO } from './dto/cycle-checker.dto';
import { CycleCheckerDateRequest, ItemIdRequest } from './dto/cycle-checker.request';
import { ItemCategoryIdReq } from './dto/item-category-id.request';
import { MaterialPreperationRequest } from './dto/material-preperation.req';
import { ItemCodeRequest } from './dto/item-code.request.dto';
import { PlantRoleRequest } from './dto/plant-role-req';
import { PreparedStockRequest } from './dto/prepared-stock-req';
import { QtyRequest } from './dto/qty-request';
import { ItemRemovedQty } from './dto/remove-stock-qty.dto';
import { SaleOrderIdRequest } from './dto/sale-order-id.request';
import { SizeIdRequest } from './dto/size-request';
import { ItemIDRequest } from './dto/stock-for-itemid-.request';
import { StockInputRequest } from './dto/stock-input.request';
import { StockItemRequest } from './dto/stock-item.request';
import { PackingBomRequest } from './packing-bom.request';
import { StockService } from './stock.service';
import { UnitRequest } from './dto/unit.id.request';
import { StockIdReq } from './dto/stock-id-req';
import { BarcodeReq } from './dto/barcode-req';
import { MaterialGridRequest } from './dto/material-preparation.request';
import { GRNLocationMappingRequest } from './dto/location-mapping-req';
import { invoiceNumberRequest } from '../grn/dto/invoice-number-req';
import { LocationRequest } from './dto/location-id.request';
import { ProductConversionReq } from './dto/product-conversion.req';
import { UnitIdRequest } from '../store-consumption/dto/unit-id.request';
import { InvetoryLogdDto } from './dto/inventory-logs-dto';

@ApiTags('stock')
@Controller('stock')
export class StockController {
    constructor(
        private stockService: StockService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }
    @Post('/getAvailableStockQty')
    async getAvailableStockQty(@Body() stockItemRequest: StockItemRequest): Promise<AvailableStockQtyResponseModel> {
        try {
            return await this.stockService.getAvailableStockQty(stockItemRequest);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(AvailableStockQtyResponseModel, err);
        }
    }

    @Post('/getInventoryStockQty')
    async getInventoryStockQty(@Body() stockItemRequest: StockItemRequest): Promise<AvailableStockQtyResponseModel> {
        try {
            return await this.stockService.getInventoryStockQty(stockItemRequest);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(AvailableStockQtyResponseModel, err);
        }
    }

    @Post('/getAllStockData')
    async getAllStockData(@Body() plantrolereq?: PlantRoleRequest): Promise<AllStockResponseModel> {
        console.log('hiiii');

        try {
            return await this.stockService.getAllStockData(plantrolereq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllStockResponseModel, error);
        }
    }

    @Post('/getAllStockDataForReport')
    async getAllStockDataForReport(@Body() req?: stockDropdownData): Promise<AllStockResponseModel> {


        try {
            return await this.stockService.getAllStockDataForReport(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllStockResponseModel, error);
        }
    }


    @Post('/AssignInventoryStock')
    async AssignInventoryStock(@Body() stockReq: StockInputRequest): Promise<boolean> {
        try {
            return await this.stockService.AssignInventoryStock(stockReq);
        } catch (error) {
            return false;
        }
    }

    @Post('/updateRemovedAssignedQtyForSo')
    async updateRemovedAssignedQtyForSo(@Body() stockReq: ItemRemovedQty): Promise<CommonResponse> {
        try {
            return await this.stockService.updateRemovedAssignedQtyForSo(stockReq);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAvailableStockSosForConsumption')
    async getAvailableStockSosForConsumption(@Body() req?: UnitRequest): Promise<SaleOrderDropDownResponseModel> {
        try {
            return await this.stockService.getAvailableStockSosForConsumption(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(SaleOrderDropDownResponseModel, err);
        }
    }
    @Post('/getAvailableStockItemSos')
    async getAvailableStockItemSos(@Body() req?: ItemIDRequest): Promise<SaleOrderDropDownResponseModel> {
        try {
            return await this.stockService.getAvailableStockItemSos(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(SaleOrderDropDownResponseModel, err);
        }
    }


    @Post('/getAvailableStockSosForReturns')
    async getAvailableStockSosForReturns(): Promise<SaleOrderDropDownResponseModel> {
        try {
            return await this.stockService.getAvailableStockSosForReturns();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(SaleOrderDropDownResponseModel, err);
        }
    }


    @Post('/getAvailableStockForSO')
    async getAvailableStockForSO(@Body() saleOrderReq: SaleOrderIdRequest): Promise<StockQtyResponseModel> {
        try {
            return await this.stockService.getAvailableStockForSO(saleOrderReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(StockQtyResponseModel, err);
        }
    }

    @Post('/AssignDummyPackingInventoryStock')
    async AssignDummyPackingInventoryStock(@Body() stockReq: StockInputRequest): Promise<boolean> {
        try {
            return await this.stockService.AssignDummyPackingInventoryStock(stockReq);
        } catch (err) {
            return false
        }
    }



    @Post('/getAvailableStockItemCategories')
    async getAvailableStockItemCategories(@Body() req: UnitRequest): Promise<ItemCategoriesDropDownResponseModel> {
        try {
            return await this.stockService.getAvailableStockItemCategories(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(ItemCategoriesDropDownResponseModel, err);
        }
    }

    @Post('/getAvailableStockItemSubCategories')
    async getAvailableStockItemSubCategories(@Body() req: ItemCategoryIdReq): Promise<ItemSubCategoriesDropDownResponse> {
        try {
            return await this.stockService.getAvailableStockItemSubCategories(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(ItemSubCategoriesDropDownResponse, err);
        }
    }

    @Post('/getAvailableStockItems')
    async getAvailableStockItems(@Body() req: CategorySubCategoryReq): Promise<ItemsDropDownResponseModel> {
        try {
            return await this.stockService.getAvailableStockItems(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(ItemsDropDownResponseModel, err);
        }
    }

    @Post('/getAvailableStockTransferItems')
    async getAvailableStockTransferItems(@Body() req: CategorySubCategoryReq): Promise<ItemsDropDownResponseModel> {
        try {
            return await this.stockService.getAvailableStockTransferItems(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(ItemsDropDownResponseModel, err);
        }
    }

    // @Post('/getAvailableStockSizes')
    // async getAvailableStockSizes(@Body() req: SizeIdRequest): Promise<SizesDropDownResponseModel> {
    //     try {
    //         return await this.stockService.getAvailableStockSizes(req);
    //     } catch (err) {
    //         return this.applicationExceptionhandler.returnException(SizesDropDownResponseModel, err);
    //     }
    // }

    @Post('/getAvailableTransferStockQty')
    async getAvailableTransferStockQty(@Body() req: QtyRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getAvailableTransferStockQty(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getAvailableStockSoItems')
    async getAvailableStockSoItems(@Body() req: SaleOrderIdRequest): Promise<GetAvailableStockResponse> {
        try {
            return await this.stockService.getAvailableStockSoItems(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(GetAvailableStockResponse, err);
        }
    }

    @Post('/stockEntry')
    async stockEntry(@Body() dto: StockDto): Promise<CommonResponse> {
        try {
            return await this.stockService.stockEntry(dto);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/stockEdit')
    async stockEdit(@Body() dto: StockDto): Promise<CommonResponse> {
        try {
            return await this.stockService.stockEdit(dto);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/stockConversion')
    async stockConversion(@Body() dto: ProductConversionModel): Promise<CommonResponse> {
        try {
            return await this.stockService.stockConversion(dto);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getStockDetailsForItemId')
    async getStockDetailsForItemId(@Body() req: ItemIDRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getStockDetailsForItemId(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/moveLeftOverQtyIntoBulk')
    async moveLeftOverQtyIntoBulk(@Body() req?: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.moveLeftOverQtyIntoBulk(req);
        }
        catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getavailbleItemsInStock')
    async getavailbleItemsInStock(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getavailbleItemsInStock(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getPhysicalQuantityForItemId')
    async getPhysicalQuantityForItemId(@Body() req: ItemIDRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getPhysicalQuantityForItemId(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getFromPosForProductConversion')
    async getFromPosForProductConversion(@Body() req: ProductConversionReq): Promise<CommonResponse> {
        try {
            return await this.stockService.getFromPosForProductConversion(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/cancelledSoStockUpdate')
    async cancelledSoStockUpdate(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.cancelledSoStockUpdate(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getPoNumberForProductConversion')
    async getPoNumberForProductConversion(@Body() req: ProductConversionReq): Promise<CommonResponse> {
        try {
            return await this.stockService.getPoNumberForProductConversion(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getPackingItemsForSoId')
    async getPackingItemsForSoId(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getPackingItemsForSoId(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getTransferredSosDataForStockGrid')
    async getTransferredSosDataForStockGrid(@Body() req?: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getTransferredSosDataForStockGrid(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getPackingBomReport')
    async getPackingBomReport(@Body() req?: PackingBomRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getPackingBomReport(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getProsUintDropForSoReport')
    async getProsUintDropForSoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getProsUintDropForSoReport(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error);
        }
    }
    @Post('getSoDropForBomReport')
    async getSoDropForBomReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getSoDropForBomReport(req);
        } catch (error) {
            return error;
        }
    }

    @Post('getSoDropForStockReport')
    async getSoDropForStockReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getSoDropForStockReport(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getItemSubDropForStockReport')
    async getItemSubDropForStockReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getItemSubDropForStockReport(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getItemDropForStockReport')
    async getItemDropForStockReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getItemDropForStockReport(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getBrandDropForStockReport')
    async getBrandDropForStockReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getBrandDropForStockReport(req);
        } catch (error) {
            return error;
        }
    }


    @Post('/saveCycleCheckerEntry')
    async CycleCheckerEntry(@Body() cycleCheckerDTO: CycleCheckerDTO): Promise<CommonResponse> {
        try {
            return await this.stockService.CycleCheckerEntry(cycleCheckerDTO, false);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getCycleCheckerData')
    async getCycleCheckerData(): Promise<CommonResponse> {
        try {
            return await this.stockService.getCycleCheckerData();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getCycleCheckerTableData')
    async getCycleCheckerTableData(): Promise<CommonResponse> {
        try {
            return await this.stockService.getCycleCheckerTableData();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/cycleCheckerApproval')
    async cycleCheckerApproval(@Body() cycleCheckerDTO: CycleCheckerDTO): Promise<CommonResponse> {
        try {
            return await this.stockService.cycleCheckerApproval(cycleCheckerDTO, false);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/updateStockToBulk')
    async updateStockToBulk(@Body() req: SaleOrderIdRequest): Promise<CommonResponse> {
        console.log('--re')
        try {
            return await this.stockService.updateStockToBulk(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/createMaterilaPreperation')
    async createMaterilaPreperation(@Body() req: MaterialPreperationRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.createMaterilaPreperation(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getPreparedMaterialForItem')
    async getPreparedMaterialForItem(@Body() req: PreparedStockRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getPreparedMaterialForItem(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }




    @Post('/getPackingMaterialInfo')
    async getPackingMaterialInfo(@Body() req: ItemCodeRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getPackingMaterialInfo(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getPreparedAvailableStockQty')
    async getPreparedAvailableStockQty(@Body() req: StockIdReq): Promise<CommonResponse> {
        try {
            return await this.stockService.getPreparedAvailableStockQty(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }


    @Post('/getMaterialPreparationData')
    async getMaterialPreparationData(@Body() req: MaterialGridRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getMaterialPreparationData(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getExcessInventoryReport')
    async getExcessInventoryReport(@Body() req:UnitIdRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getExcessInventoryReport(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getPreparedStockByBarcode')
    async getPreparedStockByBarcode(@Body() req: BarcodeReq): Promise<CommonResponse> {
        try {
            return await this.stockService.getPreparedStockByBarcode(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getDummyItems')
    async getDummyItems(@Body() req: SaleOrderIdRequest): Promise<ItemsDetailsResponseModel> {
        try {
            return await this.stockService.getDummyItems(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(ItemsDetailsResponseModel, err);
        }
    }
    @Post('/getSoDropDown')
    async getSoDropDown(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getSoDropDown(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getItemDropDown')
    async getItemDropDown(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getItemDropDown(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getStatusDropDown')
    async getStatusDropDown(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getStatusDropDown(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getPreparedProductsData')
    async getPreparedProductsData(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getPreparedProductsData(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getStockQtyForCycleChecker')
    async getStockQtyForCycleChecker(@Body() req: ItemIdRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getStockQtyForCycleChecker(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getReasonsForProdConversion')
    async getReasonsForProdConversion(): Promise<CommonResponse> {
        try {
            return await this.stockService.getReasonsForProdConversion();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getReasonsForCycleChecker')
    async getReasonsForCycleChecker(): Promise<CommonResponse> {
        try {
            return await this.stockService.getReasonsForCycleChecker();
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getSOAndSoitemCombData')
    async getSOAndSoitemCombData(@Body() req?: ItemIDRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getSOAndSoitemCombData(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getLocationsForCycleChecker')
    async getLocationsForCycleChecker(@Body() req: BrandReqForLocation): Promise<CommonResponse> {
        try {
            return await this.stockService.getLocationsForCycleChecker(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/createLocationMappedStock')
    async createLocationMappedStock(@Body() req: GRNLocationMappingRequest): Promise<CommonResponse> {
        try {
            console.log('locationMapReq')
            console.log(req)
            return await this.stockService.createLocationMappedStock(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getLocationWiseStockByGrn')
    async getLocationWiseStockByGrn(@Body() req: invoiceNumberRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getLocationWiseStockByGrn(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getLocationsForStockReport')
    async getLocationsForStockReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getLocationsForStockReport(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getNoLocationPhysicalQuantity')
    async getNoLocationPhysicalQuantity(@Body() req: ItemIDRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getNoLocationPhysicalQuantity(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getStockDetailsForItem')
    async getStockDetailsForItem(@Body() req: any): Promise<CommonResponse> {
        try {
            return await this.stockService.getStockDetailsForItem(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getAvailableStockLocations')
    async getAvailableStockLocations(@Body() req: QtyRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getAvailableStockLocations(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getPreviousTransactionsByGrn')
    async getPreviousTransactionsByGrn(@Body() req: LocationRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getPreviousTransactionsByGrn(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getLocationWiseStockByItem')
    async getLocationWiseStockByItem(@Body() req: ItemIDRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getLocationWiseStockByItem(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getLocationWiseStockBySaleOrder')
    async getLocationWiseStockBySaleOrder(@Body() req: ItemIDRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getLocationWiseStockBySaleOrder(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getLocationsForItem')
    async getLocationsForItem(@Body() req: ItemIDRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getLocationsForItem(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getSaveStockForLocationPending')
    async getSaveStockForLocationPending(@Body() req: LocationUpdateRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getSaveStockForLocationPending(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

    @Post('/getClassificationReportData')
  async getClassificationReportData(req:ReClassificationReq):Promise<CommonResponse> {
    try {
      return await this.stockService.getClassificationReportData(req);
    } catch (err) {
      return this.applicationExceptionhandler.returnException(CommonResponse, err);
    }
  }
    @Post('/getToItemsForProductConversion')
    async getToItemsForProductConversion(@Body() req: ProductConversionReq): Promise<CommonResponse> {
        try {
            return await this.stockService.getToItemsForProductConversion(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/getSOAndSoitemData')
    async getSOAndSoitemData(@Body() req: ItemIDRequest): Promise<CommonResponse> {
        try {
            return await this.stockService.getSOAndSoitemData(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }
    @Post('/createinventiryLogs')
    async createinventiryLogs(@Body() dto: InvetoryLogdDto): Promise<any> {
        try {
            return await this.stockService.createinventiryLogs(dto);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(CommonResponse, err);
        }
    }

}
